<template>
  <div>    
    <div class="widget-container">
     
      <DxForm
        id="form"
        :form-data="state.formData"
        label-mode='outside'
        :read-only='false'
        :show-colon-after-label='true'
        label-location='top'
        :min-col-width='300'
        :col-count='1'
        ref="formMaster"
      >
        <DxGroupItem caption="Βασικά Στοιχεία" :col-span="2" :col-count="2">

        <DxSimpleItem
            data-field="active_ind"
            editor-type="dxCheckBox"
            :editor-options="{
                readOnly: false
            }"
        >
            <DxLabel text="Ενεργή"/>
        </DxSimpleItem>

        <DxSimpleItem
          data-field="parent_geo_location_id"
          editor-type="dxSelectBox"
          :editor-options="{
            dataSource: state.LookupCustomDS_serres_geo_locations,
            displayExpr: 'descr',
            valueExpr:'geo_location_id'
          }"
        >
          <DxLabel text="Γεωγραφική Περιοχή"/>
        </DxSimpleItem>

        <DxSimpleItem
              data-field="priority_ind"
          >
            <DxLabel text="Σειρά Προτεραιότητας"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="joomla_content_id"
        >
            <DxLabel text="Άρθρο CMS Joomla"/>
            <!-- <DxRequiredRule message="Υποχρεωτικό πεδίο" /> -->
        </DxSimpleItem>

        <DxSimpleItem
            data-field="yahoo_meteo_location_id"
        >
            <DxLabel text="Yahoo Meteo Location ID"/>
            <!-- <DxRequiredRule message="Υποχρεωτικό πεδίο" /> -->
        </DxSimpleItem>

        <DxSimpleItem
            data-field="google_map"
            :editor-options="{
                readOnly: true
            }"
        >
            <DxLabel text="Συντεταγμένες & Zoom"/>
        </DxSimpleItem>

      </DxGroupItem>

      <DxGroupItem caption="Εικόνα" :col-span="1" :col-count="1">

        <DxSimpleItem>
            <DxFileUploader
                :ref="fileUploaderRef"
                :multiple="false"
                accept="image/*"
                upload-mode="instantly"
                upload-url="https://nautilia-yachting.com/backoffice-2msWE34rfER39023m0e23e2/app/data/file-upload.php"
                @value-changed="e => files = e.value"
                @uploaded="onUploaded"
                @upload-error="onUploadError"
            />
        </DxSimpleItem>

        <DxSimpleItem            
            caption="Image Preview"
            template="imageTemplate"
        >
            <DxLabel text="Εικόνα"/>
        </DxSimpleItem>

        <DxSimpleItem
            data-field="image_path"
            :editor-options="{
                readOnly: false
            }"
        >
            <DxLabel text="Διαδρομή Εικόνας"/>
        </DxSimpleItem>

      </DxGroupItem>

      <template #imageTemplate="{ }">
        <img :src="state.formData.image_path" alt="Charter Base" style="width: 200px; height: auto;">
      </template>

      </DxForm>

      <div class="dx-fieldset-header">Μετάφραση Ονόματος Γεωγραφικής Τοποθεσίας</div>

      <div class="dx-fieldset">
        
                <DxDataGrid
                    :key-expr="id"
                    :data-source="state.CustomStoreGrid_serres_geo_locations_lang"
                    :columns="columns"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :show-column-lines="true"
                    :show-row-lines="true"
                    :row-alternation-enabled="true"
                    :focused-row-enabled="true"
                    :width="gridWidth"
                    :style="{ 'max-width': maxWidth }"
                    ref="gridDetail_serres_geo_locations_lang"
                    :word-wrap-enabled="true"

                    @init-new-row="onInitNewRow"
                    @row-validating="onRowValidating"

                    v-model:focused-row-key="focusedRowKey"

                >
                <DxPaging 
                        :enabled="true"
                        :page-size="5"
                    />

                    <DxFilterRow :visible="true"/>
                    <DxHeaderFilter :visible="true"/>
        
                    <DxPager
                        :visible="true"
                        :allowed-page-sizes="pageSizes"
                        :display-mode="displayMode"
                        :show-page-size-selector="true"
                        :show-info="true"
                        :show-navigation-buttons="true"
                    />

                    <DxGroupPanel :visible="false"/>
                    <DxSorting mode="multiple"/>

                    <DxEditing
                        :allow-updating="true"
                        :allow-adding="true"
                        :allow-deleting="true"
                        mode="batch"
                    />

                    <DxColumn
                        data-field="lang_id"
                        caption="Γλώσσα"
                    >
                        <DxLookup
                            :data-source="state.LookupCustomDS_serres_languages" 
                            value-expr="lang_id"
                            display-expr="title"
                        />
                        <DxRequiredRule message="Υποχρεωτικό πεδίο"/>
                    </DxColumn>

                    <DxColumn
                        data-field="descr"
                        caption="Περιγραφή"
                        :hiding-priority="110"
                    >
                    </DxColumn>

                    <DxColumn
                        data-field="short_descr"
                        caption="Σύντομη Περιγραφή"
                        :hiding-priority="120"
                    >
                    </DxColumn>

                    <DxColumn
                        data-field="search_descr"
                        caption="Περιγραφή για Αναζήτηση"
                        :hiding-priority="130"
                    >
                    </DxColumn>

                    <DxColumn
                        data-field="alias"
                        caption="Alias"
                        :hiding-priority="140"
                    >
                    </DxColumn>
                </DxDataGrid>
            </div>

            <div class="dx-fieldset-header">Χαρακτηριστικά Γεωγραφικής Τοποθεσίας</div>

            <div class="dx-fieldset">
                <DxDataGrid
                    :key-expr="geo_location_facility_id"
                    :data-source="state.CustomStoreGrid_serres_geo_location_facilities"
                    :columns="columns"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :show-column-lines="true"
                    :show-row-lines="true"
                    :row-alternation-enabled="true"
                    :focused-row-enabled="true"
                    :width="gridWidth"
                    :style="{ 'max-width': maxWidth }"
                    ref="gridDetail_serres_geo_location_facilities"
                    :word-wrap-enabled="true"

                    @exporting="onExporting"
                    @rowClick="openForm"
                    @init-new-row="onInitNewRow"
                    @row-validating="onRowValidating"
                    @selection-changed="onSelectionChanged"

                    v-model:focused-row-key="focusedRowKey"

                >
                    <DxSelection
                        mode="single"
                    />
                    <DxPaging 
                        :enabled="true"
                        :page-size="5"
                    />

                    <DxFilterRow :visible="true"/>
                    <DxHeaderFilter :visible="true"/>

                    <DxPager
                        :visible="true"
                        :allowed-page-sizes="pageSizes"
                        :display-mode="displayMode"
                        :show-page-size-selector="true"
                        :show-info="true"
                        :show-navigation-buttons="true"
                    />

                    <DxGroupPanel :visible="false"/>
                    <DxSorting mode="multiple"/>

                    <DxEditing
                        :allow-updating="true"
                        :allow-adding="true"
                        :allow-deleting="true"
                        mode="row"
                    />

                    <DxColumn
                        data-field="facility_type_id"
                        caption="Τύπος Εγκατάστασης"
                    >
                        <DxLookup
                            :data-source="state.LookupCustomDS_serres_geo_location_facility_types" 
                            value-expr="facility_type_id"
                            display-expr="description"
                        />
                        <DxRequiredRule message="Υποχρεωτικό πεδίο"/>
                    </DxColumn>

                    <DxColumn
                        data-field="description"
                        caption="Περιγραφή"
                        :hiding-priority="110"
                    >
                    </DxColumn>

                </DxDataGrid>

            </div>
            <div class="dx-fieldset">

                <DxDataGrid
                    :key-expr="geo_location_facility_lang_id"
                    :data-source="state.CustomStoreGrid_serres_geo_location_facilities_lang"
                    :columns="columns"
                    :allow-column-reordering="true"
                    :allow-column-resizing="true"
                    :column-auto-width="true"
                    :show-borders="true"
                    :show-column-lines="true"
                    :show-row-lines="true"
                    :row-alternation-enabled="true"
                    :focused-row-enabled="true"
                    :width="gridWidth"
                    :style="{ 'max-width': maxWidth }"
                    ref="gridDetail_serres_geo_location_facilities_lang"
                    :word-wrap-enabled="true"

                    @exporting="onExporting"
                    @rowClick="openForm"
                    @init-new-row="onInitNewRow"
                    @row-validating="onRowValidating"

                    v-model:focused-row-key="focusedRowKey"

                >
                <DxPaging 
                        :enabled="true"
                        :page-size="5"
                    />

                    <DxFilterRow :visible="true"/>
                    <DxHeaderFilter :visible="true"/>
        
                    <DxPager
                        :visible="true"
                        :allowed-page-sizes="pageSizes"
                        :display-mode="displayMode"
                        :show-page-size-selector="true"
                        :show-info="true"
                        :show-navigation-buttons="true"
                    />

                    <DxGroupPanel :visible="false"/>
                    <DxSorting mode="multiple"/>

                    <DxEditing
                        :allow-updating="true"
                        :allow-adding="true"
                        :allow-deleting="true"
                        mode="batch"
                    />

                    <DxColumn
                        data-field="lang_id"
                        caption="Γλώσσα"
                    >
                        <DxLookup
                            :data-source="state.LookupCustomDS_serres_languages" 
                            value-expr="lang_id"
                            display-expr="title"
                        />
                        <DxRequiredRule message="Υποχρεωτικό πεδίο"/>
                    </DxColumn>

                    <DxColumn
                        data-field="description"
                        caption="Περιγραφή"
                        :hiding-priority="110"
                    >
                    </DxColumn>

                </DxDataGrid>

            </div>

            <div class="dx-fieldset-header">Γεωγραφική Τοποθεσία στον Χάρτη</div>
            <div class="map">
                  <GMapMap
                      :center="centerOfMap"
                      :zoom="zoom"
                      :options="{
                            zoomControl: true,
                            mapTypeControl: true,
                            scaleControl: true,
                            streetViewControl: true,
                            rotateControl: true,
                            fullscreenControl: true,
                      }"
                      ref="itieraryDetailMapRef"
                      map-type-id="terrain"
                      style="height: 500px"
                  >
                  <GMapMarker
                    :key="index"
                    v-for="(m, index) in markers"
                    :draggable="true"
                    :position="m.position"
                    @dragend="onDragend"
                    :clickable="true"
                  />
                  </GMapMap>
                </div>


          <div id="buttons">
              <DxToolbar>
                  <dxItem 
                      location="after"
                      widget="dxButton"
                      @click="onClickSave"
                      :options="{
                          icon: 'save',
                          text: 'Αποθηκευση'
                      }"
                  >
                  </dxItem>
                  <dxItem 
                      location="after" 
                      widget="dxButton"
                      @click="onClickClose"
                      :options="{
                          icon: 'close',
                          text: 'Κλείσιμο'
                      }"
                      >
                  </dxItem>
              </DxToolbar>
        </div>
    </div>
</div>
</template>


<script>

  const URL_SERVICE = NYParameters.Host.URI + 'serres_geo_locations'
  const URL_SERVICE_serres_geo_locations = NYParameters.Host.URI + 'serres_geo_locations'
  const URL_SERVICE_LOOKUP_serres_languages = NYParameters.Host.URI + 'serres_languages'
  const URL_SERVICE_LOOKUP_serres_geo_location_facility_types = NYParameters.Host.URI + 'serres_geo_location_facility_types'
  

  //Grids
  const URL_SERVICE_serres_geo_locations_lang = NYParameters.Host.URI + 'serres_geo_locations_lang'
  const URL_SERVICE_serres_geo_location_facilities = NYParameters.Host.URI + 'serres_geo_location_facilities'

  const URL_SERVICE_serres_geo_location_facilities_lang = NYParameters.Host.URI + 'serres_geo_location_facilities_lang'

  //SEQUENCE
  const URL_SERVICE_serres_geo_locations_nextval_VIEW = NYParameters.Host.URI + 'serres_geo_locations_nextval_VIEW'

  const centerOfGreece = { lat: 39.3643, lng: 21.9212 }

  import CustomStore from 'devextreme/data/custom_store';

  import { reactive, onMounted, computed } from 'vue';  
  import 'whatwg-fetch';

  import NYParameters from '../../ny-globals'

  import {
      DxForm, 
      DxLabel,
      DxSimpleItem, 
      DxRequiredRule,
      DxGroupItem
  } from 'devextreme-vue/form';

  import DxDataGrid, {
      DxColumn,
      DxEditing, 
      DxPaging,
      DxPager,
      DxGroupPanel,
      DxSorting,
      DxFilterRow,
      DxHeaderFilter,
      DxLookup,
      DxSelection
  } from 'devextreme-vue/data-grid';

  import DxFileUploader from "devextreme-vue/file-uploader";

  //import DxMap from 'devextreme-vue/map';

  import DxToolbar, { DxItem } from 'devextreme-vue/toolbar';

  export default {
    name: 'GeoLocationForm',
    components: {
      //DxMap,
      DxForm,
      DxLabel,
      DxSimpleItem,
      DxRequiredRule,
      DxDataGrid,
      DxColumn,
      DxEditing,
      DxPaging,
      DxPager,
      DxGroupPanel,
      DxSorting,
      DxFilterRow,
      DxHeaderFilter,
      DxLookup,
      DxToolbar,
      DxItem,
      DxGroupItem,
      DxSelection,
      DxFileUploader
    },
    data() {
        return {
            title: "Ναύλος",
            calendarOptions: { value: new Date() },
            textAreaOptions: { placeholder: 'Προσθήκη σχολίου..'},
            pageSizes: [5, 10, 20],
            GMAPIKey: NYParameters.googleMapsAPIKey,
            //dataGridRefKey: DATAGRIDREFKEY,
            dateBoxEditorOptions: {
              //pickerType: 'rollers',
              type: 'date',
              displayFormat: 'dd/MM/yyyy',
              dateSerializationFormat: 'yyyy-MM-dd',
              invalidDateMessage: 'Λάθος Ημερομηνία',
              showClearButton: true,
              min: new Date(),
              max: new Date(2030, 11, 31)
            },
            rowIndex: -1,
            centerOfMap: centerOfGreece,
            zoom: 7,
            markers: [{
                position: centerOfGreece,
              }
            ]
        }
    },
    props: {
      geo_location_id: {
          type: Number,
          required: true
      }
    },
    watch: {
      geo_location_id(newValue, oldValue) {
          this.$emit('geo_location_id-value-changed', newValue, oldValue);
          this.loadFormData(newValue);
      }
    },
    setup(props) {
      const gridWidth = computed(() => '100%'); // set the width to 100%
      const maxWidth = computed(() => '1000px'); // set the max-width to 800px
      const state = reactive({
        formData: {},

        LookupCustomDS_serres_geo_locations: new CustomStore({
            key: 'geo_location_id',
            loadMode: 'raw',
            load: () => sendRequest(URL_SERVICE_serres_geo_locations),
            byKey: (key) => sendRequestByKey(URL_SERVICE_serres_geo_locations + "/" + encodeURIComponent(key)),
        }),

        serres_geo_locations_nextval_VIEW:  new CustomStore({
                key: 'id',
                loadMode: 'raw',
                cacheRawData: 'false',
                load: () => sendRequest(URL_SERVICE_serres_geo_locations_nextval_VIEW),
        }),

        CustomStoreGrid_serres_geo_locations_lang: new CustomStore({
            key: 'geo_locations_lang_id',
            //loadMode: 'raw',
            load: () => sendRequest(URL_SERVICE_serres_geo_locations_lang + '?filter=geo_location_id,eq,' +  state.formData.geo_location_id),
            insert: (values) => sendRequest(URL_SERVICE_serres_geo_locations_lang, 'POST', values),
            update: (key, values) => sendRequest(URL_SERVICE_serres_geo_locations_lang + '/' + encodeURIComponent(key), 'PUT', values),
            remove: (key) => sendRequest(URL_SERVICE_serres_geo_locations_lang + '/' + encodeURIComponent(key), 'DELETE'),
            byKey: (key) => sendRequestByKey(URL_SERVICE_serres_geo_locations_lang + "/" + encodeURIComponent(key)),
        }),

        CustomStoreGrid_serres_geo_location_facilities: new CustomStore({
            key: 'geo_location_facility_id',
            //loadMode: 'raw',
            load: () => sendRequest(URL_SERVICE_serres_geo_location_facilities + '?filter=geo_location_id,eq,' +  state.formData.geo_location_id),
            insert: (values) => sendRequest(URL_SERVICE_serres_geo_location_facilities, 'POST', values),
            update: (key, values) => sendRequest(URL_SERVICE_serres_geo_location_facilities + '/' + encodeURIComponent(key), 'PUT', values),
            remove: (key) => sendRequest(URL_SERVICE_serres_geo_location_facilities + '/' + encodeURIComponent(key), 'DELETE'),
            byKey: (key) => sendRequestByKey(URL_SERVICE_serres_geo_location_facilities + "/" + encodeURIComponent(key)),
        }),

        CustomStoreGrid_serres_geo_location_facilities_lang: new CustomStore({
            key: 'geo_location_facility_lang_id',
            //loadMode: 'raw',
            load: () => sendRequest(URL_SERVICE_serres_geo_location_facilities_lang + '?filter=geo_location_facility_id,eq,92'),
            insert: (values) => sendRequest(URL_SERVICE_serres_geo_location_facilities_lang, 'POST', values),
            update: (key, values) => sendRequest(URL_SERVICE_serres_geo_location_facilities_lang + '/' + encodeURIComponent(key), 'PUT', values),
            remove: (key) => sendRequest(URL_SERVICE_serres_geo_location_facilities_lang + '/' + encodeURIComponent(key), 'DELETE'),
            byKey: (key) => sendRequestByKey(URL_SERVICE_serres_geo_location_facilities_lang + "/" + encodeURIComponent(key)),
        }),

        LookupCustomDS_serres_geo_location_facility_types:  new CustomStore({
                key: 'facility_type_id',
                loadMode: 'raw',
                load: () => sendRequest(URL_SERVICE_LOOKUP_serres_geo_location_facility_types + '?order=order_type_ind'),
                byKey: (key) => sendRequestByKey(URL_SERVICE_LOOKUP_serres_geo_location_facility_types + "/" + encodeURIComponent(key)),
          }),
          
        LookupCustomDS_serres_languages:  new CustomStore({
                key: 'lang_id',
                loadMode: 'raw',
                load: () => sendRequest(URL_SERVICE_LOOKUP_serres_languages + '?order=title'),
                byKey: (key) => sendRequestByKey(URL_SERVICE_LOOKUP_serres_languages + "/" + encodeURIComponent(key)),
        }),
          
        CustomStoreMain: new CustomStore({
            key: 'geo_location_id',
            //loadMode: 'raw',
            load: () => sendRequest(URL_SERVICE),
            insert: (values) => sendRequest(URL_SERVICE, 'POST', values),
            update: (key, values) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'PUT', values),
            remove: (key) => sendRequest(URL_SERVICE + '/' + encodeURIComponent(key), 'DELETE'),
            byKey: (key) => sendRequestByKey(URL_SERVICE + "/" + encodeURIComponent(key)),
        }),
      });

      // 
      //  Based on: https://js.devexpress.com/Demos/WidgetsGallery/Demo/DataGrid/CRUDOperations/Vue/GreenMist/
      //
      const sendRequest = (url, method = 'GET', values = {}) => {
          //console.log('LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
          if (method === 'GET') {
                return fetch(url, {
                    method,
                    credentials: 'include',
                })
                .then(response => response.json())
                .then(json => {
                  return json.records;
                })
            }
            return fetch(url, {
                method,
                body: JSON.stringify(values),
                headers: {
                    'Content-Type': 'application/json', //'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8',
                },
                credentials: 'include',
            }).then((result) => {
                if (result.ok) {
                    return result.text().then((text) => text && JSON.parse(text));
                }
                return result.json().then((json) => {
                    throw json.Message;
                });
            });
      };

      const sendRequestByKey = (url, method = 'GET') => {
          //console.log('LOG: ' + url + ' METHOD: ' + method + ' VALUES: ' + JSON.stringify(values, null, 4));
          return fetch(url, {
                    method,
                    headers: {
                        'Accept': 'application/json',
                    },
                    credentials: 'include',
                })
                .then(response => response.json())
      };

      const saveData = async () => {
          // console.log('Save data');
          await state.CustomStoreMain.update(state.formData.geo_location_id, state.formData);
      };

      const insertData = async () => {
          // console.log('Insert data');
          await state.CustomStoreMain.insert(state.formData);
      };

      const clearForm = () => {
          state.formData = {};
      };

      var isGridValidated = true;
  
      onMounted(async () => {
          //state.formData = await state.CustomStoreMain.byKey(props.geo_location_id);
          if (props.geo_location_id != null) state.formData = await state.CustomStoreMain.byKey(props.geo_location_id);

      });

      return {
          saveData,
          insertData,
          clearForm,
          gridWidth,
          maxWidth,
          state,
          isGridValidated
      };
    },
    methods: {
        async loadFormData(id) {

            if (id != null) {
                this.isInsertMode = false
                this.state.formData = await this.state.CustomStoreMain.byKey(id)

                this.setMapMarker(this.state.formData.google_map)

            } else {
                this.getNextVal().then(value => {
                    this.isInsertMode = true
                    this.state.formData = {/*entry_date: new Date().toISOString().split('T')[0]*/}
                    this.state.formData.geo_location_id = value
                })
            }

            await this.$refs.gridDetail_serres_geo_location_facilities.instance.refresh()
            await this.$refs.gridDetail_serres_geo_locations_lang.instance.refresh()
        },

        async getNextVal() {
            //console.log('getNextVal')
            this.state.serres_geo_locations_nextval_VIEW.clearRawDataCache()
            let row = await this.state.serres_geo_locations_nextval_VIEW.load()
            return row[0].nextval
        },

        onClickSave: async function() {

            const formValidator = this.dataForm.validate();
            this.isGridValidated = true
            let formSaved = false

            if (formValidator.isValid) {
                if (!this.isInsertMode) {
                    await this.saveData()
                    formSaved = true
                } else {
                    await this.insertData()
                    formSaved = true
                }
            }

            await this.$refs.gridDetail_serres_geo_location_facilities.instance.saveEditData()
            await this.$refs.gridDetail_serres_geo_locations_lang.instance.saveEditData()

            if (this.isGridValidated && formSaved) this.$emit('closePopupEvent', true)

        },
        onClickClose: function() {
            this.$emit('closePopupEvent', true);
        },
        onInitNewRow(row) {
            row.data.geo_location_id = this.state.formData.geo_location_id
        },
        onSelectionChanged(e) {
            var selectedRow = e.currentSelectedRowKeys[0]
            console.log(selectedRow)
            //this.selectedCharterAgreementCode = e.currentSelectedRowKeys[0];
        },
        onRowValidating(e) {
          this.isGridValidated = this.isGridValidated && e.isValid;
        },

        /*
        onValueChanged(e) {
            const reader: FileReader = new FileReader();
            reader.onload = (args) => {
                if (typeof args.target?.result === "string" && imageRef?.value) {
                imageRef.value.src = args.target.result;
                }
            };
            reader.readAsDataURL(e.value![0]); // convert to base64 string
        },
        */

        onUploaded(e) {
            console.log('File uploaded:', e);
            //image_path = '234234';

            //this.state.formData.image_path = NYParameters.Host.URIUploadFolderCharterBases + e.file.name
            this.$refs.formMaster.instance.getEditor('image_path').option('value', NYParameters.Host.URIUploadFolderCharterBases + e.file.name)

            //cellInfo.setValue("images/employees/" + e.request.responseText);
            //retryButtonVisible.value = false;
        },

        onUploadError(e) {
            console.error('Upload failed:', e);
            const xhttp = e.request;

            if (xhttp.status === 400) {
                e.message = e.error.responseText;
                console.error('Error 400: Bad Request -', e.message);
            } else if (xhttp.readyState === 4 && xhttp.status === 0) {
                e.message = "Connection refused - Check network or server status";
                console.error(e.message);
            } else if (xhttp.status === 500) {
                e.message = "Server error - Check server logs for more details";
                console.error(e.message);
            }
            
            //retryButtonVisible.value = true;
        },

        setMapMarker(google_map_point) {

            if (google_map_point != null) {

                const matchResult = google_map_point.match(/\(\s*(-?\d+(\.\d+)?)\s*,\s*(-?\d+(\.\d+)?)\s*\):(\d+)/);

                if (matchResult !== null) {
                    // The actual values start from index 1, since index 0 is the full match.
                    const lat = Number(matchResult[1]); // This is the latitude
                    const lng = Number(matchResult[3]); // This is the longitude (skip index 2 because it's the decimal part of latitude)
                    const zoom = Number(matchResult[5]); // This is the zoom level (skip index 4 because it's the decimal part of longitude)

                    if (!isNaN(lat) && !isNaN(lng) && !isNaN(zoom)) {
                        /*
                        console.log(zoom);
                        console.log(lat);
                        console.log(lng);
                        */
                        
                        this.zoom = zoom;
                        this.centerOfMap = { lat, lng };
                        this.markers = [{
                            position: this.centerOfMap,
                        }];
                    }
                } else {
                    console.error("Λάθος μορφή ");
                }
            } else {
                console.error("Οι συντεταγμένες είναι άδειες");
            }
            
        },
        /*
        addMarker(e) {
            console.log("addMarker(e)")
            this.mapMarkers.push({ location: e.location });
        },
        removeMarker() {
          console.log("removeMarker()")
            this.mapMarkers.pop();
        },
        */
        onDragend(e) {
          let lat = e.latLng.lat()
          let lng = e.latLng.lng()
          let zoom = this.$refs.itieraryDetailMapRef.$mapObject.zoom

          if (lat) {
            //this.dataGrid.cellValue(this.rowIndex, "google_map_point", `(${lat}, ${lng}):${zoom}`);
            console.log("this.state.formData.google_map before")
            console.log(this.state.formData.google_map)

            this.$refs.formMaster.instance.getEditor('google_map').option('value', `(${lat}, ${lng}):${zoom}`)

            //this.state.formData.google_map = `(${lat}, ${lng}):${zoom}`

            console.log("this.state.formData.google_map 2 after")
            console.log(this.state.formData.google_map)
          }
          
        }
    },
    computed: {
        dataGrid_serres_geo_locations_lang: function() {
            return this.$refs.gridDetail_serres_geo_locations_lang.instance;
        },
        dataForm: function() {
            return this.$refs.formMaster.instance;
        },
    }
};
</script>

<style lang="scss">

</style>

<style scoped>

/* Targets editing row */
::ng-deep .dx-edit-row {
    box-shadow: 3px 3px 5px 5px #ccc;
}

.grid-map-container {
  display: flex;
  flex-wrap: wrap;
}

.grid {
  flex: 1;
  padding: 10px;
  max-width: 50%; /* Adjust this as needed for the desired width on desktop and tablet */
  box-sizing: border-box;
}

.map {
  flex: 1;
  padding: 4% 2% 5% 2%;;
  max-width: 50%; /* Adjust this as needed for the desired width on desktop and tablet */
  box-sizing: border-box;
}

@media (max-width: 768px) {
  /* Adjust the layout for tablets (e.g., 768px) */
  .grid {
    max-width: 100%; /* Full width for tablets */
  }

  .map {
    max-width: 100%; /* Full width for tablets */
  }
}

#form {
   margin-top: 25px;
}
.caption {
    font-size: 18px;
    font-weight: 500;
}
.option {
    margin-top: 10px;
}
</style>
